module.exports = __webpack_public_path__ + "img/lg5.8d3be2cd.jpg";